import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useAuth } from '../../context/AuthContext'; // Import AuthContext
import { signOut } from 'firebase/auth';
import { auth } from './../../firebaseConfig'; // Firebase auth instance
import './MobileHeader.css';
import Logo from './../../assets/logos/LogoColour.svg';
import OrangeLogo from './../../assets/logos/orangelogo.svg';
import MenuIcon from './../../assets/icons/burger-menu-right-svgrepo-com.svg';
import CloseIcon from './../../assets/icons/ui/to-left-menu.svg';
import GradientButton from '../ui/GradientButton/GradientButton';
import OrangeGradientButton from '../ui/OrangeGradientButton/OrangeGradientButton';
import ProfilePhoto from './../../assets/Images/pricing/1.png';
import LogoutIcon from './../../assets/icons/logout.svg';
import i18n from "../../i18n";
import EnglishFlag from "../../assets/icons/ui/eng.svg";
import RussianFlag from "../../assets/icons/ui/ru.svg";

const MobileHeader: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth(); // Get user from AuthContext
  const { t } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  // Logout handler
  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log('User logged out');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  // Language switcher
  const switchLanguage = () => {
    const newLang = currentLang === "en" ? "ru" : "en";
    i18n.changeLanguage(newLang);
    localStorage.setItem("language", newLang);
    setCurrentLang(newLang);
  };

  return (
    <header className="mobile-header">
      <div className="mobile-header-content">
        <Link to="/" className="mobile-logo">
          <img src={location.pathname === '/teens' ? OrangeLogo : Logo} alt="Logo" />
        </Link>
        <div style={{ display: 'flex', gap: '5px'}}>
        <li className="language-switcher" onClick={switchLanguage}>
              {currentLang === "en" ? (
                <img src={EnglishFlag} alt="Switch to Russian" className="flag-icon-mobile " />
              ) : (
                <img src={RussianFlag} alt="Switch to English" className="flag-icon-mobile " />
              )}
            </li>
        <img
          src={menuOpen ? CloseIcon : MenuIcon}
          alt="Menu Icon"
          className="menu-icon"
          onClick={toggleMenu}
        />
        </div>
      </div>

      {/* Collapsible Menu */}
      {menuOpen && (
        <nav className="mobile-nav">
          <ul className="mobile-nav-links">
            <li>
              <Link to="/" className={location.pathname === '/' ? 'mobile-nav active' : 'mobile-nav'} onClick={toggleMenu}>
                {t('home')}
              </Link>
            </li>
            <li>
              <Link to="/masters" className={location.pathname === '/masters' ? 'mobile-nav active' : 'mobile-nav'} onClick={toggleMenu}>
                {t('masters')}
              </Link>
            </li>
            {/* <li>
              <Link to="/programs" className={location.pathname === '/programs' ? 'mobile-nav active' : 'mobile-nav'} onClick={toggleMenu}>
                {t('programs')}
              </Link>
            </li> */}
            <li>
              <Link to="/events" className={location.pathname === '/events' ? 'mobile-nav active' : 'mobile-nav'} onClick={toggleMenu}>
                {t('events')}
              </Link>
            </li>
            <li>
              <Link to="/teens" className={location.pathname === '/teens' ? 'mobile-nav activeTeens' : 'mobile-nav'} onClick={toggleMenu}>
                {t('teens')}
              </Link>
            </li>
            <li>
              <Link to="/calendar" className={location.pathname === '/calendar' ? 'mobile-nav active' : 'mobile-nav'} onClick={toggleMenu}>
                {t('calendar')}
              </Link>
            </li>

            {/* User Login/Profile */}
            <li>
              {user ? (
                <div className="user-info">
                  {location.pathname === '/teens' ? (
                    <OrangeGradientButton width='190px'>
                      <div className="user-container">
                        <img
                          src={user.photoURL || ProfilePhoto} // Default avatar if no photoURL
                          alt="User Avatar"
                          className="user-avatar"
                        />
                        <span className="username">
                          {user.displayName || user.email || 'User'}
                        </span>
                        <img
                          src={LogoutIcon}
                          alt="Logout"
                          className="logout-icon"
                          onClick={handleLogout}
                          title="Logout"
                        />
                      </div>
                    </OrangeGradientButton>
                  ) : (
                    <GradientButton>
                      <div className="user-container">
                        <img
                          src={user.photoURL || ProfilePhoto} // Default avatar if no photoURL
                          alt="User Avatar"
                          className="user-avatar"
                        />
                        <span className="username">
                          {user.displayName || user.email || 'User'}
                        </span>
                        <img
                          src={LogoutIcon}
                          alt="Logout"
                          className="logout-icon"
                          onClick={handleLogout}
                          title="Logout"
                        />
                      </div>
                    </GradientButton>
                  )}
                </div>
              ) : (
                <Link to="/login" onClick={toggleMenu}>
                  {location.pathname === '/teens' ? (
                    <OrangeGradientButton width='190px'>{t('login_signup')}</OrangeGradientButton>
                  ) : (
                    <GradientButton>{t('login_signup')}</GradientButton>
                  )}
                </Link>
              )}
            </li>

            {/* Language Switcher */}
            <li className="language-switcher" onClick={switchLanguage}>
              {currentLang === "en" ? (
                <img src={EnglishFlag} alt="Switch to Russian" className="flag-icon" />
              ) : (
                <img src={RussianFlag} alt="Switch to English" className="flag-icon" />
              )}
            </li>

          </ul>
        </nav>
      )}
    </header>
  );
};

export default MobileHeader;
